import './AccountTypeFilter.scss';
import React from 'react';
import { connect } from 'react-redux';
import Store from 'state/Store';
import {
  getAccountTypeSelectionForFilterType,
  getLabelForFilterType,
  getPerformanceFilterOptions,
  PRR_FILTER_TYPE
} from 'state/performance/PerformancePageSelectors';
import { selectedAccountType } from 'state/performance/PerformancePageActions';
import Dropdown from 'components/shared/Dropdown/Dropdown';

const AccountTypeFilter = ({ selection, options, filterType }) => {
  const label = getLabelForFilterType(filterType);
  const selected = { title: selection, value: selection };

  const onSelectionChange = (e, selected) => {
    Store.dispatch(selectedAccountType(selected.value, filterType));
  };

  return (
    <div className="account-type-filter-selector">
      <div className="filter-by-account-type-label">
        <span>{label}</span>
      </div>
      <Dropdown
        options={options}
        onChange={onSelectionChange}
        selected={selected}
        hasFooter={filterType !== PRR_FILTER_TYPE}
        footerName="Add Custom Group"
        footerLink={'profile/customize-account-view'}
      />
    </div>
  );
};

const mapStateToProps = (state, { filterType }) => {
  return {
    selection: getAccountTypeSelectionForFilterType(state, filterType),
    options: getPerformanceFilterOptions(state, filterType),
    filterType
  };
};

export default connect(mapStateToProps)(AccountTypeFilter);
